export default __webpack_public_path__ + "static/media/G0720.34I-26450_-16300_0.1666268160000.c2d1d396.jpg";